import { Link } from 'react-router-dom';
import { imageUrl } from '../lib/images';

export default function Footer() {
  const logoUrl = 'https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/djurs-massage-logo.jpg';
  const bookingUrl = 'https://djursmassage.app4.geckobooking.dk/site/booking.php?show=new_booking&icCode=69a506a6f06a0ca7022b880e8f6bcb65b11332&bId=11332&aDIfH=1&dTpl=1&sSToken=267bea05a53684a4a7d7ad2e6bae564a';
  const giftcardUrl = 'https://djursmassage.app4.geckobooking.dk/site/index.php?icCode=e6868204e7e11708974faa3b47f24d3db11332&dTpl=1';

  return (
    <footer className="bg-[#12243A] text-white pt-14 pb-10 border-t border-[#1E3A5F]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 pb-10 border-b border-slate-700/60">
          {/* Col 1: About & Logo */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img
                src={imageUrl(logoUrl, 'width=240,quality=90,format=auto')}
                alt="Djurs Massage"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <div className="pt-1">
              <a
                href="https://www.facebook.com/djursmassage.dk"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Djurs Massage på Facebook"
                className="inline-flex items-center gap-2 text-white/90 hover:text-white text-xs font-medium transition-colors"
              >
                <i className="fa-brands fa-facebook-f text-white" aria-hidden="true" />
                <span>Følg os på Facebook</span>
              </a>
            </div>
          </div>

          {/* Col 2: Treatments */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold tracking-wider uppercase text-white">
              Behandlinger
            </h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li>
                <Link to="/behandlinger/fysiurgisk-massage" className="hover:text-white transition-colors">
                  Fysiurgisk massage
                </Link>
              </li>
              <li>
                <Link to="/behandlinger/zoneterapi" className="hover:text-white transition-colors">
                  Zoneterapi
                </Link>
              </li>
              <li>
                <Link to="/behandlinger/ems-traening" className="text-[#C9A770] hover:text-white transition-colors font-medium">
                  EMS dragt
                </Link>
              </li>
              <li>
                <Link to="/behandlinger/relax-massage" className="hover:text-white transition-colors">
                  Relax massage
                </Link>
              </li>
              <li>
                <Link to="/behandlinger/voksbehandling" className="hover:text-white transition-colors">
                  Voksbehandling
                </Link>
              </li>
              <li>
                <Link to="/behandlinger/pedicure-fodbehandling" className="hover:text-white transition-colors">
                  Pedicure & Fodpleje
                </Link>
              </li>
              <li>
                <Link to="/behandlingstyper" className="hover:text-white transition-colors">
                  Behandlingstyper & teknikker
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Quick Navigation */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold tracking-wider uppercase text-white">
              Information
            </h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li>
                <Link to="/om-os" className="hover:text-white transition-colors">
                  Om os & behandlerne
                </Link>
              </li>
              <li>
                <Link to="/anmeldelser" className="hover:text-white transition-colors">
                  Kundeanmeldelser
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-white transition-colors">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/job" className="text-[#C9A770] hover:text-white transition-colors font-medium">
                  Jobansøgning
                </Link>
              </li>
              <li>
                <Link to="/betingelser-mm" className="hover:text-white transition-colors">
                  Handelsbetingelser
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact & Details */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold tracking-wider uppercase text-white">
              Kontakt & Klinik
            </h4>
            <div className="space-y-2 text-sm text-white/90">
              <div className="flex items-start gap-2">
                <i className="fa-solid fa-location-dot text-white mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <span className="font-semibold text-white">Djurs Massage</span>
                  <p className="text-white/85">Poppelvej 52, 8550 Ryomgård</p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <i className="fa-solid fa-phone text-white shrink-0" aria-hidden="true" />
                <a
                  href="tel:28583907"
                  className="hover:underline transition-colors whitespace-nowrap font-medium text-white"
                >
                  28 58 39 07
                </a>
              </div>

              <div className="flex items-center gap-2">
                <i className="fa-solid fa-envelope text-white shrink-0" aria-hidden="true" />
                <a
                  href="mailto:djursmassage@gmail.com"
                  className="hover:underline transition-colors whitespace-nowrap text-white"
                >
                  djursmassage@gmail.com
                </a>
              </div>

              <div className="pt-2">
                <a
                  href={bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full py-2.5 px-4 bg-white text-[#041032] font-bold text-xs rounded-full hover:bg-slate-100 transition-colors shadow-sm"
                >
                  <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                  <span>Book tid nu</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar with CVR in copyright */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/90">
          <p>© {new Date().getFullYear()} Djurs Massage • CVR: 28053150. Alle rettigheder forbeholdes.</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="whitespace-nowrap font-medium text-white">Priser fra 300 kr. (600 kr./time)</span>
            <span className="text-white/40">•</span>
            <span className="whitespace-nowrap">Dankort, MobilePay & Kontant</span>
            <span className="text-white/40">•</span>
            <Link to="/betingelser-mm" className="text-white/90 hover:text-white transition-colors underline">
              Betingelser mm
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
